import ShopArticlesListPagingResultModelBase from '../_generated/modelBases/shop-articles-list-paging-result-model-base';

export default class ShopArticlesListPagingResultModel extends ShopArticlesListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
